import { useMap, useMapEvents } from "react-leaflet";

import { IMainMap } from "../hooks/useMainMap";
import { useEffect } from "react";


interface MapInitProps {
    state: IMainMap;
}

const MapInit = ({ state }: MapInitProps): JSX.Element => {

    const map = useMap();

    const updateState = () => {
        state.mapState.setState({
            centre: map.getCenter(),
            zoom: map.getZoom(),
            layerId: state.currentTileLayer?.id
        });
    };

    useMapEvents({
        move: updateState,
        zoom: updateState
    });

    useEffect(() => {
        if (!state.currentTileLayer)
            return;

        let zoom = state.currentTileLayer.maxZoom;

        if (state.currentTileLayer.id === state.mapState.state?.layerId && state.mapState.state?.zoom !== null)
            zoom = state.mapState.state?.zoom;

        map.setView(
            state.mapState.state?.centre ?? state.config.defaultCentre, 
            zoom
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);

    return <></>;
};

export default MapInit;